import React, { useState, useEffect  } from 'react';
import { X, Send, Calendar, Image as ImageIcon, Search, ChevronRight, ChevronLeft, Users } from 'lucide-react';
import axios from 'axios';

interface CampaignModalProps {
  isOpen: boolean;
  onClose: () => void;
  tenantId: string;
  customers: any[];
  campaignToEdit?: any;
}

const CampaignModal: React.FC<CampaignModalProps> = ({ isOpen, onClose, tenantId, customers, campaignToEdit }) => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedInModal, setSelectedInModal] = useState<string[]>([]);
  // --- LÓGICA DE UPLOAD [NOVO] ---
  const [isUploading, setIsUploading] = useState(false);
  const [hideScheduled, setHideScheduled] = useState<boolean>(false);
  const [scheduledIds, setScheduledIds] = useState<string[]>([]);
  useEffect(() => {
  if (!isOpen || !tenantId) return;
  const fetchScheduled = async () => {
    try {
      const res = await axios.get(
        `https://zapshop.app/api/campaigns/${tenantId}/queued-customers`
      );
      setScheduledIds(res.data.queued_ids || []);
    } catch (e) {
      console.error('Erro ao buscar agendados:', e);
    }
  };
  fetchScheduled();
}, [isOpen, tenantId]);  

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setIsUploading(true);
    const uploadData = new FormData();
    uploadData.append('file', file);

    try {
      // Envia para a rota que criamos no server.js
      const response = await axios.post('/api/upload', uploadData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (response.data.url) {
        setFormData(prev => ({ ...prev, media_url: response.data.url }));
      } else {
        alert('Erro no upload: Link não gerado.');
      }
    } catch (error) {
      console.error('Erro de upload:', error);
      alert('Falha ao enviar arquivo para o servidor.');
    } finally {
      setIsUploading(false);
    }
  };
  // -------------------------------

  
  const [formData, setFormData] = useState({
    name: '',
    message: 'Olá [NOME], tudo bem?',
    media_url: '',
    scheduled_at: ''
  });

// --- EFEITO PARA PREENCHER DADOS NA EDIÇÃO ---
  useEffect(() => {
    if (isOpen && campaignToEdit) {
      // MODO EDIÇÃO: Preenche os campos com os dados da campanha selecionada
      setFormData(prev => ({
        ...prev,
        name: campaignToEdit.name || '',
        message: campaignToEdit.message_template || '',
        media_url: campaignToEdit.media_url || '',
        // Formata a data para o padrão de input datetime-local (YYYY-MM-DDTHH:mm)
        scheduled_at: campaignToEdit.scheduled_at ? new Date(campaignToEdit.scheduled_at).toISOString().slice(0, 16) : ''
      }));
      // Pula para a etapa de formatação de texto para facilitar (opcional)
      setStep(1); 
    } else if (isOpen && !campaignToEdit) {
      // MODO CRIAÇÃO: Garante que os campos venham limpos
      setFormData({
        name: '',
        message: '',
        media_url: '',
        scheduled_at: ''
      });
      setSelectedInModal([]);
      setStep(1);
    }
  }, [isOpen, campaignToEdit]);

// Filtro de busca para o Passo 2
const filteredCustomers = customers.filter(c => {
  const matchSearch =
    c.name?.toLowerCase().includes(search.toLowerCase()) ||
    c.phone?.includes(search);
  const matchScheduled = hideScheduled ? !scheduledIds.includes(c.id) : true;
  return matchSearch && matchScheduled;
});

  // Seleção individual com trava de 50
  const toggleCustomer = (id: string) => {
    if (selectedInModal.includes(id)) {
      setSelectedInModal(selectedInModal.filter(i => i !== id));
    } else {
      if (selectedInModal.length >= 50) {
        alert("Limite de segurança atingido: máximo 50 clientes por disparo.");
        return;
      }
      setSelectedInModal([...selectedInModal, id]);
    }
  };

const handleFinalSubmit = async () => {
    if (selectedInModal.length === 0) return alert("Selecione pelo menos um cliente.");
    if (!formData.name.trim()) return alert("Dê um nome para sua campanha.");

    setLoading(true);
    try {
      // 1. Montamos o "pacote" de dados uma vez só
      const payload = {
        tenant_id: tenantId,
        customer_ids: selectedInModal,
        name: formData.name,
        message: formData.message,
        media_url: formData.media_url,
        scheduled_at: formData.scheduled_at || null
      };

      // 2. A função decide se vai Editar ou Criar
      if (campaignToEdit) {
        // MODO EDIÇÃO: Usa PUT e aponta para o ID da campanha
        await axios.put(`https://zapshop.app/api/campaigns/${campaignToEdit.id}`, payload);
        alert('Campanha atualizada com sucesso!');
      } else {
        // MODO CRIAÇÃO: Usa o POST original que você já tinha
        await axios.post('https://zapshop.app/api/campaigns/setup', payload);
        alert('Campanha agendada com sucesso!');
      }

      // 3. Limpa tudo e fecha o modal
      onClose();
      setStep(1);
    } catch (error) {
      console.error("Erro ao salvar campanha:", error);
      alert("Ocorreu um erro ao salvar a campanha.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

return (
    <div className="fixed inset-0 bg-surface-900/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
      <div className="bg-white text-surface-900 rounded-2xl shadow-2xl w-full max-w-xl border border-surface-100 flex flex-col overflow-hidden animate-fade-in">
        
        {/* CABEÇALHO - PREMIUM LIGHT */}
        <div className="px-6 py-4 border-b border-surface-100 flex justify-between items-center bg-surface-50">
          <div>
            <h3 className="font-bold text-lg flex items-center gap-2 text-surface-900">
              {step === 1 ? <Send size={18} className="text-brand-600"/> : <Users size={18} className="text-brand-600"/>}
              {step === 1 ? 'Configurar Mensagem' : 'Selecionar Público'}
            </h3>
            <p className="text-[10px] text-gray-400 uppercase font-bold tracking-widest">Passo {step} de 2</p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-white rounded-full transition text-gray-400 hover:text-red-500">
            <X size={20}/>
          </button>
        </div>

        {/* CORPO DO MODAL */}
        <div className="p-6 max-h-[500px] overflow-y-auto custom-scrollbar">
          {step === 1 ? (
            <div className="space-y-5 animate-slide-up">
              <div>
                <label className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">Nome da Campanha</label>
                <input 
                  className="input-primary w-full py-3 mt-1"
                  placeholder="Ex: Promoção Dia das Mães"
                  value={formData.name}
                  onChange={e => setFormData({...formData, name: e.target.value})}
                />
              </div>

              <div>
                <label className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">Mensagem (Use [NOME])</label>
                <textarea 
                  rows={4}
                  className="input-primary w-full p-3 mt-1 resize-none"
                  value={formData.message}
                  onChange={e => setFormData({...formData, message: e.target.value})}
                />
              </div>

              <div className="flex flex-col gap-5">
                <div>
                  <label className="text-[10px] font-bold text-gray-500 uppercase flex items-center gap-1">
                    <Calendar size={12}/> Agendamento
                  </label>
                  <input 
                    type="datetime-local"
                    className="input-primary w-full py-2.5 mt-1"
                    value={formData.scheduled_at}
                    onChange={e => setFormData({...formData, scheduled_at: e.target.value})}
                  />
                </div>

                <div>
                  <label className="text-[10px] font-bold text-gray-500 uppercase flex items-center gap-1">
                    <ImageIcon size={12}/> Link da Imagem / Upload
                  </label>
                  <div className="flex flex-col gap-2 mt-1">
                      <div className="flex gap-2">
                        <label className={`flex items-center justify-center px-4 py-2.5 rounded-xl border border-dashed cursor-pointer transition-all ${isUploading ? 'bg-gray-50 opacity-50' : 'bg-white hover:bg-gray-50 border-gray-300'}`}>
                          <input type="file" className="hidden" accept="image/*,video/*" onChange={handleFileUpload} disabled={isUploading} />
                          <span className="text-[10px] font-bold text-gray-600">{isUploading ? '...' : '📷 Upload'}</span>
                        </label>
                        <input
                          className="input-primary flex-1 py-2.5 text-xs"
                          placeholder="Ou cole o link..."
                          value={formData.media_url}
                          onChange={e => setFormData({...formData, media_url: e.target.value})}
                          readOnly={isUploading}
                        />
                      </div>
                      {formData.media_url && (
                        <div className="relative w-fit group">
                          <img src={formData.media_url} alt="Preview" className="h-16 w-auto rounded-lg border border-surface-200 object-cover" />
                          <button onClick={() => setFormData({...formData, media_url: ''})} className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full p-0.5 shadow-lg"><X size={10} /></button>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="space-y-4 animate-slide-up">
              <div className="relative">
                <Search className="absolute left-4 top-3 text-gray-400" size={18}/>
                <input 
                  className="input-primary w-full pl-11 pr-4 py-3 rounded-full text-sm"
                  placeholder="Buscar por nome ou telefone..."
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                />
              </div>
              
              <div className="flex items-center justify-between gap-3 flex-wrap mt-3 bg-surface-50 p-3 rounded-xl border border-surface-100">
                <label className="flex items-center gap-2 cursor-pointer select-none">
                  <div onClick={() => setHideScheduled(h => !h)} className={`w-10 h-5 rounded-full transition-colors flex items-center px-0.5 ${hideScheduled ? 'bg-brand-600' : 'bg-gray-300'}`}>
                    <div className={`w-4 h-4 bg-white rounded-full shadow transition-transform ${hideScheduled ? 'translate-x-5' : 'translate-x-0'}`} />
                  </div>
                  <span className="text-xs text-gray-600 font-bold">Ocultar agendados</span>
                </label>

                <button
                  type="button"
                  onClick={() => {
                    const notYetSelected = filteredCustomers.filter(c => !selectedInModal.includes(c.id)).slice(0, 50 - selectedInModal.length);
                    if (notYetSelected.length === 0) return;
                    setSelectedInModal(prev => [...prev, ...notYetSelected.map(c => c.id)]);
                  }}
                  disabled={selectedInModal.length >= 50}
                  className="text-[10px] font-bold text-brand-600 hover:bg-brand-50 px-3 py-1.5 rounded-full border border-brand-100 transition disabled:opacity-40"
                >
                  + Selecionar +50
                </button>
              </div>

              <div className="space-y-2">
                {filteredCustomers.length === 0 ? (
                  <div className="py-10 text-center text-gray-400">
                    <Users size={40} className="mx-auto mb-2 opacity-20"/>
                    <p className="text-sm">Nenhum cliente encontrado.</p>
                  </div>
                ) : (
                  filteredCustomers.map((c) => (
                    <label key={c.id} className={`flex items-center justify-between p-3 rounded-xl border transition-all cursor-pointer ${selectedInModal.includes(c.id) ? 'bg-brand-50 border-brand-200 ring-1 ring-brand-100' : 'bg-white border-surface-100 hover:bg-surface-50'}`}>
                      <div className="flex items-center gap-3">
                        <div className={`w-5 h-5 rounded border flex items-center justify-center transition-colors ${selectedInModal.includes(c.id) ? 'bg-brand-600 border-brand-600' : 'bg-white border-gray-300'}`}>
                          {selectedInModal.includes(c.id) && <ChevronRight size={14} className="text-white"/>}
                        </div>
                        <div>
                          <p className="text-sm font-bold text-surface-900">{c.name || 'Sem Nome'}</p>
                          <p className="text-[10px] text-gray-400 font-mono">{c.phone}</p>
                        </div>
                      </div>
                      <input type="checkbox" className="hidden" checked={selectedInModal.includes(c.id)} onChange={() => toggleCustomer(c.id)} />
                    </label>
                  ))
                )}
              </div>
            </div>
          )}
        </div>

{/* RODAPÉ PREMIUM - AJUSTE FINAL */}
<div className="p-4 md:p-6 border-t border-surface-100 bg-surface-50 flex justify-between items-center sticky bottom-0">
  <div className="flex flex-col">
    <span className={`text-[11px] font-bold transition-colors ${selectedInModal.length >= 50 ? 'text-orange-600' : 'text-brand-600'}`}>
      {selectedInModal.length} SELECIONADOS
    </span>
    <span className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">LIMITE: 50 POR ENVIO</span>
  </div>

  <div className="flex items-center gap-2 md:gap-4">
    {step === 2 && (
      <button 
        onClick={() => setStep(1)} 
        className="px-3 md:px-4 h-11 text-xs font-bold text-gray-500 hover:text-surface-900 transition-all flex items-center gap-1"
      >
        <ChevronLeft size={16}/> Voltar
      </button>
    )}
    
    <button 
      onClick={step === 1 ? () => setStep(2) : handleFinalSubmit}
      disabled={loading}
      className={`h-11 px-6 md:px-10 rounded-2xl text-sm font-bold flex items-center justify-center gap-2 transition-all shadow-lg active:scale-95 ${
        step === 1 
        ? 'bg-brand-600 hover:bg-brand-500 text-white shadow-brand-600/20' 
        : 'bg-emerald-600 hover:bg-emerald-500 text-white shadow-emerald-600/20'
      } disabled:opacity-50 disabled:cursor-not-allowed`}
    >
      {step === 1 ? (
        <>Próximo <ChevronRight size={18}/></>
      ) : (
        <>{loading ? 'Processando...' : 'Agendar Disparo'} <Send size={18}/></>
      )}
    </button>
  </div>
</div>

      </div>
    </div>
  

  );
};

export default CampaignModal;
